<template>
    <div>
        <v-icon class="col" color="green" v-if="diff.old === null">
            add
        </v-icon>
        <v-icon class="col" color="red" v-else-if="diff.new === null">
            remove
        </v-icon>
        <v-icon class="col" color="orange" v-else>
            arrow_forward
        </v-icon>
    </div>
</template>

<script>
 export default {
     name: 'IconsBetweenColumns',
     props: ['diff'],
 }
</script>